"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isChildOfType = void 0;
var tslib_1 = require("tslib");
/* eslint-disable import/export */
var react_1 = tslib_1.__importDefault(require("react"));
function isChildOfType(child, type) {
    if (typeof child === "undefined" || child === null)
        return false;
    if (typeof child === "string") {
        return type === "text";
    }
    if (typeof child === "number") {
        return type === "number";
    }
    if (react_1.default.isValidElement(child)) {
        if (typeof type === "string") {
            return child.type === type;
        }
        // React Hot Loader 会对组件进行代理。使用 createElement() 返回的 element.type 才是实际的类型
        // remark: https://github.com/gaearon/react-hot-loader/issues/304#issuecomment-223222772
        return child.type === react_1.default.createElement(type, {}).type;
    }
    return false;
}
exports.isChildOfType = isChildOfType;
/* eslint-enable import/export */
//# sourceMappingURL=is-child-of-type.js.map